export default __webpack_public_path__ + "media/images/home/language_2025_lg-96b2949fe70556c1a89fcb5219efe976.jpg";